import { useScrollPositionStore } from "~/stores/scrollPosition";

export default ({ app }) => {
  if (typeof window === "undefined") return;

  // Lưu path và vị trí cuộn trang trước khi chuyển hướng vào store 
  app.router.beforeEach((to, from, next) => {
    if (!from.path) {
      next();
      return;
    }

    // Get current position
    const position = window.pageYOffset || document.documentElement.scrollTop;

    // vào trang product detail thì scroll về đầu trang nên không cần lưu vị trí
    if (!to.name || !to.name.toLowerCase().includes("product")) {
      const scrollPositionStore = useScrollPositionStore();

      // Save the position
      scrollPositionStore.savePosition(from.fullPath, position);
    }

    next();
  });

  // Improved restore position logic with better event handling
  let restoreAttempts = 0;
  const MAX_RESTORE_ATTEMPTS = 5;

  // Tìm vị trí cuộn trang đã lưu trong store và cuộn đến vị trí đó
  app.router.afterEach((to) => {
    // Reset attempts counter
    restoreAttempts = 0;

    // Try to restore scroll position
    tryRestorePosition(to);
  });

  // Function to attempt scroll restoration with retries
  function tryRestorePosition(to) {
    if (restoreAttempts >= MAX_RESTORE_ATTEMPTS) {
      return;
    }

    restoreAttempts++;

    setTimeout(() => {
      const scrollPositionStore = useScrollPositionStore();
      const positions = scrollPositionStore.positions;

      // Check if we have a saved position for this route
      if (positions[to.fullPath] !== undefined) {
        const savedPosition = positions[to.fullPath];

        // Only restore if we're not at the top already
        if (savedPosition > 0) {
          window.scrollTo({
            top: savedPosition,
            behavior: "auto",
          });

          // Check if the restoration was successful
          setTimeout(() => {
            const currentPosition = window.pageYOffset || document.documentElement.scrollTop;

            // If we're not at the expected position, try again
            if (Math.abs(currentPosition - savedPosition) > 10 && restoreAttempts < MAX_RESTORE_ATTEMPTS) {
              tryRestorePosition(to);
            }
          }, 100);
        }
      }
    }, 100 * restoreAttempts); // Increasing delays for each attempt
  }

  // Xử lý nút Back/Forward của trình duyệt
  if (typeof window !== "undefined") {
    window.addEventListener("popstate", () => {
      // Wait for Vue Router to update the route
      setTimeout(() => {
        const currentPath = window.location.pathname + window.location.search;

        const scrollPositionStore = useScrollPositionStore();
        const positions = scrollPositionStore.positions;

        // Check for exact match or path without query params
        let savedPosition = positions[currentPath];

        if (savedPosition === undefined) {
          const pathWithoutQuery = window.location.pathname;
          savedPosition = positions[pathWithoutQuery];
        }

        if (savedPosition !== undefined && savedPosition > 0) {
          window.scrollTo({
            top: savedPosition,
            behavior: "auto",
          });
        }
      }, 100);
    });
  }
};
